import React, { Fragment } from 'react'

import GlgTabs from 'SharedComponents/glg_tabs'
import EmailDeliveryReportsContainer from '../../containers/delivery_reports/email_delivery_reports_container'
import TextMessageDeliveryReportsContainer from '../../containers/delivery_reports/text_message_delivery_reports_container'
import { Row, Col } from 'react-flexbox-grid'
import PropTypes from 'prop-types'

const reportsPerPage = 20
const buildPageNumbers = (totalReports) => {
  const pages = []
  let totalPages = totalReports / reportsPerPage
  totalPages = totalPages - Math.floor(totalPages) > 0 ? Math.floor(totalPages) + 1 : Math.floor(totalPages)

  for (let page = 1; page <= totalPages; ++page){
    pages.push(page)
  }

  return pages
}

const DeliveryReportsComponent = (props) => {
  const formatDate = (date) => {
    const dateFormat = props.dateTimeFormatting?.date_format || 'MDY';
    const timeFormat = props.dateTimeFormatting?.time_format || 'am_pm';

    const add_padding = (num) => (num < 10 ? '0' + num : '' + num);

    let datePart = '';
    const year = date.getFullYear();
    const month = add_padding(date.getMonth() + 1);
    const day = add_padding(date.getDate());

    switch (dateFormat) {
      case 'YMD':
        datePart = `${year}-${month}-${day}`;
        break;
      case 'DMY':
        datePart = `${day}-${month}-${year}`;
        break;
      case 'MDY':
      default:
        datePart = `${month}-${day}-${year}`;
        break;
    }

    let timePart = '';
    const minutes = add_padding(date.getMinutes());
    const seconds = add_padding(date.getSeconds());

    if (timeFormat === 'am_pm') {
      let hour = date.getHours();
      const ampm = hour >= 12 ? 'PM' : 'AM';
      hour = hour % 12;
      hour = hour === 0 ? 12 : hour;
      timePart = `${hour}:${minutes}:${seconds} ${ampm}`;
    } else {
      const hour = add_padding(date.getHours());
      timePart = `${hour}:${minutes}:${seconds}`;
    }
    return `${datePart} ${timePart}`;
  }

  return (
    <Fragment>
      <GlgTabs>
        { props.hasChannel.email && (
          <div label={ window.I18n.t('marketing_campaigns.components.delivery_reports.delivery_reports_component.email') }>
            <Row className='no-margin'>
              <Col className='add-padding-all-20' xs={ 12 }>
                <EmailDeliveryReportsContainer
                  filterDropdownValues={props.filterDropdownValues.email}
                  perPage={reportsPerPage}
                  loadEmailDeliveryReportsPath={props.paths.load_email_delivery_reports}
                  formatDate={formatDate}
                  buildPageNumbers={ buildPageNumbers } />
              </Col>
            </Row>
          </div>
        )}
        { props.hasChannel.textMessage && (
          <div label={ window.I18n.t('marketing_campaigns.components.delivery_reports.delivery_reports_component.text_message') }>
            <Row className='no-margin'>
              <Col className='add-padding-all-20' xs={ 12 }>
                <TextMessageDeliveryReportsContainer
                  filterDropdownValues={props.filterDropdownValues.text_message}
                  perPage={reportsPerPage}
                  loadTextMessageDeliveryReportsPath={props.paths.load_text_message_delivery_reports}
                  formatDate={formatDate}
                  buildPageNumbers={ buildPageNumbers } />
              </Col>
            </Row>
          </div>
        )}
      </GlgTabs>
    </Fragment>
  )
}

DeliveryReportsComponent.propTypes = {
  paths: PropTypes.shape({
    load_email_delivery_reports: PropTypes.string.isRequired,
    load_text_message_delivery_reports: PropTypes.string.isRequired,
  }).isRequired,
  filterDropdownValues: PropTypes.shape({
    email: PropTypes.shape({
      players: PropTypes.array.isRequired,
      subjects: PropTypes.array.isRequired,
      statuses: PropTypes.array.isRequired,
    }),
    text_message: PropTypes.shape({
      players: PropTypes.array.isRequired,
      descriptions: PropTypes.array.isRequired,
    }),
  }).isRequired,
  hasChannel: PropTypes.shape({
    email: PropTypes.number,
    textMessage: PropTypes.number,
  }).isRequired,
  dateTimeFormatting: PropTypes.shape({
    date_format: PropTypes.string,
    time_format: PropTypes.string,
  })
}

export default DeliveryReportsComponent
